import type { NotificationFrequency, NotificationSchedule } from "@qendo/notifications";
import Data from "~/util/data";

export class NotificationSettings extends Data {
    public constructor(
        public push_notifications: boolean = false,
        public upcoming_appointments: boolean = false,
        public period_prediction: boolean = false,
        public ovulation_prediction: boolean = false,
        public pain: boolean = false,
        public take_medication: boolean = false,
        public affirmations:
            | NotificationSchedule<NotificationFrequency.daily | NotificationFrequency.specific_days>
            | false = false,
        public breath:
            | NotificationSchedule<
                  NotificationFrequency.daily | NotificationFrequency.specific_days | NotificationFrequency.interval
              >
            | false = false,
        public log_pain: NotificationSchedule | false = false,
        public log_symptom: NotificationSchedule | false = false,
        public drink_water: NotificationSchedule | false = false,
        public pelvic_exercises: NotificationSchedule | false = false,
        public pelvic_floor: NotificationSchedule | false = false,
        public move_your_body: NotificationSchedule | false = false,
        public rest: NotificationSchedule | false = false,
    ) {
        super();
    }
}
